import { render } from "./tour_advance.vue?vue&type=template&id=4c9d5b6c"
import script from "./tour_advance.vue?vue&type=script&lang=js"
export * from "./tour_advance.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__